import { oidcService } from "@/auth/oidcService"
import { siteKey } from "../site"
import { getUserPreference } from "@/api/api-module1"
import store from ".."

export default {
  namespaced: true,
  state: () => ({
    user: null,
    isAuthenticated: false,
  }),
  mutations: {
    SET_USER(state, user) {
      state.user = user
      state.isAuthenticated = !!user
    },
    CLEAR_USER(state) {
      state.user = null
      state.isAuthenticated = false
    },
  },
  actions: {
    async loginOidc({ commit }) {
      await oidcService.login()
    },
    async logoutOidc({ commit }) {
      localStorage.removeItem(siteKey)

      localStorage.removeItem("wpm-dashboard-auto-refresh")
      localStorage.removeItem("wpm-executive-dashboard-auto-refresh")
      localStorage.removeItem("wpm-site-access-dashboard-auto-refresh")
      localStorage.removeItem("sms-dashboard-auto-refresh")
      localStorage.removeItem("bmm-dashboard-auto-refresh")
      localStorage.removeItem("ncm-dashboard-auto-refresh")

      localStorage.removeItem("isEnableNotiSound")

      await oidcService.logout()
      commit("CLEAR_USER")
    },
    async handleCallback({ commit }) {
      const authUser = await oidcService.handleCallback()
      if (authUser) {
        commit("SET_USER", authUser)
        const userPref = await getUserPreference()
        store.dispatch(
          "commonStore/setNotificationSoundEnabled",
          userPref.notificationSound
        )
      }
    },
    async checkUser({ commit }) {
      const authUser = await oidcService.getUser()

      if (authUser) {
        commit("SET_USER", authUser)
      } else {
        commit("CLEAR_USER")
      }
    },
    async renewToken({ commit, dispatch }) {
      try {
        const authUser = await oidcService.renewToken()
        if (authUser) {
          commit("SET_USER", authUser)
        } else {
          commit("CLEAR_USER")
          await oidcService.logout()
          window.location.reload()
        }
      } catch (error) {
        commit("CLEAR_USER")
        await oidcService.logout()
        window.location.reload()
      }
    },
  },
  getters: {
    getUserFullName: (state) => {
      return state.user ? state.user.profile.name : null
    },
    getUsername: (state) => {
      return state.user ? state.user.profile.username : null
    },
    getUserGroupPermissionName: (state) => {
      return state.user ? state.user.profile.groups : null
    },
  },
}
